import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

export const applyLeave = async (data) => {
  const res = await axiosInstance.post("/leave-portal/apply", data);
  return res.data;
};

export const getMyLeaves = async (filters = {}) => {
  const res = await axiosInstance.get("/leave-portal/my", { params: filters });
  return res.data;
};

export const cancelLeave = async (id) => {
  const res = await axiosInstance.put(`/leave-portal/cancel/${id}`);
  return res.data;
};

export const getAllLeavesPortal = async (filters = {}) => {
  const res = await axiosInstance.get("/leave-portal/all", { params: filters });
  return res.data;
};

export const approveLeavePortal = async (id, data) => {
  const res = await axiosInstance.put(`/leave-portal/approve/${id}`, data);
  return res.data;
};

export const rejectLeavePortal = async (id, data) => {
  const res = await axiosInstance.put(`/leave-portal/reject/${id}`, data);
  return res.data;
};

export const getLeaveByIdPortal = async (id) => {
  const res = await axiosInstance.get(`/leave-portal/${id}`);
  return res.data;
};